import pathToRegexp from 'path-to-regexp';
export class RouteMatcher {
  constructor(urlPattern) {
    this.urlPattern = urlPattern;
    this.keys = [];
    this.patternRegex = void 0;
    this.compiledPattern = void 0;
    this.patternRegex = pathToRegexp(urlPattern, this.keys, {
      end: true,
      start: false
    });
    this.compiledPattern = pathToRegexp.compile(urlPattern);
  }
  matches(url) {
    return this.patternRegex.test(url);
  }
  getArgs(url) {
    const matches = this.patternRegex.exec(url);
    if (matches === null) {
      return {};
    }
    const params = {};
    this.keys.forEach((key, i) => {
      params[key.name] = matches[i + 1];
    });
    return params;
  }
  getUrl(args) {
    return this.compiledPattern(args || {});
  }
}
//# sourceMappingURL=RouteMatcher.js.map